import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { colors } from "@/theme/colors";

// 店舗へ共有する自由記述の最大文字数。Backend・DB (TEXT) 側に制限は無く、
// 過大な入力を入り口で抑えるためのフロント側の上限 (JPTP_CANSEI-1382)。
const NOTE_MAX_LENGTH = 500;

type Props = {
  allergy: string;
  request: string;
  onAllergyChange: (value: string) => void;
  onRequestChange: (value: string) => void;
};

/**
 * アレルギー・ご要望 (いずれも任意) の入力セクション。入力内容は CreateCheckoutSession で
 * 予約者情報とあわせて送信し、店舗へ共有する (JPTP_CANSEI-1382)。
 */
export function AllergyRequestSection({
  allergy,
  request,
  onAllergyChange,
  onRequestChange,
}: Props) {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 700, color: colors.text, mb: 2 }}>
        {t("buyerInfo.allergyRequestTitle")}
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <TextField
          label={t("buyerInfo.allergy")}
          helperText={t("buyerInfo.allergyHint")}
          value={allergy}
          onChange={(e) => onAllergyChange(e.target.value)}
          multiline
          minRows={3}
          fullWidth
          slotProps={{ htmlInput: { maxLength: NOTE_MAX_LENGTH } }}
        />
        <TextField
          label={t("buyerInfo.request")}
          helperText={t("buyerInfo.requestHint")}
          value={request}
          onChange={(e) => onRequestChange(e.target.value)}
          multiline
          minRows={3}
          fullWidth
          slotProps={{ htmlInput: { maxLength: NOTE_MAX_LENGTH } }}
        />
      </Box>
    </Box>
  );
}
